import { render, staticRenderFns } from "./ProductVariantStamp.vue?vue&type=template&id=339ae99e&scoped=true&lang=pug"
import script from "./ProductVariantStamp.vue?vue&type=script&lang=js"
export * from "./ProductVariantStamp.vue?vue&type=script&lang=js"
import style0 from "./ProductVariantStamp.vue?vue&type=style&index=0&id=339ae99e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339ae99e",
  null
  
)

export default component.exports